
<template>
  <a :href="params ? `${to}?${params}` : to" @click="linkTo">
    <slot />
  </a>
</template>

<script>
import { mapActions } from 'vuex'
import md5 from 'js-md5'
import { jumpTo } from './utils/jump-to.js'
import { addPageTagAndNavigate } from '@/services/microFeUtil/pageTagUtils.js'
const specRoutesNames = [
  'order_details',
  'manual_order_creation',
  'order_inspection',
  'order_weighting',
  'pull_1688_orders',
  'external_storage_goods',
  'inventory_init'
]

export default {
  props: {
    to: {
      type: String,
      // required: true
    },
    params: {
      type: String,
      default: ''
    },
    menu: {
      type: Object,
      default() {
        return {}
      }
    },

  },
  methods: {
    ...mapActions('pageTag', { addPageTag: 'addPageTag' }),
    getNowFormatDate() {
      const date = new Date()
      const seperator1 = '-'
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      return year + seperator1 + month + seperator1 + strDate
    },
    linkTo(e) {
      e.preventDefault()
      let newTab = false
      const { to, params } = this
      console.log('----------- linkTo ----------', to, this.menu.title)
      this.$sensors.setWebClick({
        name: `菜单点击-${this.menu.title}-${to}`
      })
      if (to.includes('/service_support/guset_service')) {
        const currentDate = this.getNowFormatDate()
        const seller_account = this.$store.state.user.userInfoAfterLogin.sid
        const version_name = 'KJERP1.0'
        const signString = seller_account + version_name + currentDate + 'zsxjwdt'
        // const checkString = version_name + seller_account + currentDate + 'qwertZXCVB'
        const sign = md5(md5(signString))
        // const check = md5(md5(checkString))
        const url = 'https://usercenter.huice.com/#/?token='
        const resUrl = 'sealler=' + seller_account + '&version=' + version_name + '&sign=' + sign
        // const b = Buffer.from(resUrl)
        // const param = b.toString('base64')
        const param = btoa(encodeURI(resUrl))
        console.log(param, url + param)
        window.open(url + param)
      } else {
        if (specRoutesNames.includes(this.$route.name)) {
          newTab = true
        } else {
          // const parentRoute = this.$route.path.split('/')[1]
          // const route = to.split('/')[1]
          // newTab = parentRoute !== route
        }
        const linkUrl = params ? `${to}?${params}` : to

        if (newTab) {
          window.open(linkUrl)
        } else if (e.ctrlKey || e.metaKey) {
          // window.open(linkUrl)
          addPageTagAndNavigate(linkUrl, this.menu.title, { mustNew: true })
        } else {
          // this.addPageTag({
          //   title: this.menu.title,
          //   url: linkUrl
          // })
          // jumpTo(this.$router, linkUrl)
          addPageTagAndNavigate(linkUrl, this.menu.title, { strict: false })
        }
      }
    }
  }
}
</script>
